import React from 'react'

import classes from './Footer.module.css'

const Footer = () => {
    return (
        <p className={classes.footer}><span>&copy;</span>2022 Bd3 Limited</p>


    )
}

export default Footer